// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2XvbB","author":"Table_author__1KKIg","authorImage":"Table_authorImage__247hJ","unreadRow":"Table_unreadRow__1GXCe"};